import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Card, Button, Form, Row, Col, Alert, Badge, Spinner } from "react-bootstrap";
import { useAuth } from "../Context/AuthContext";
import axios from "axios";
import "../Styling/RequestLeave.css";
import { Base_URL } from "../url";

const RequestLeave = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  console.log(user);

  // ✅ Disable balance check when organisationId = 9001
  const isBalanceCheckEnabled = String(user?.organisationId) !== "9001";

  const [leaveData, setLeaveData] = useState({
    fromDate: "",
    toDate: "",
    fromHalf: "First Half",
    toHalf: "First Half",
    leaveType: "",
    note: "",
    duration: "Full Day",
    daysRequested: 0,
  });

  const [leaveBalances, setLeaveBalances] = useState({});

const [confirmationEmployeeCheck, setConfirmationEmployeeCheck] = useState(true);
const [confirmedLeaveConfig, setConfirmedLeaveConfig] = useState([]);
const [confirmedConfigLoading, setConfirmedConfigLoading] = useState(true);
  const [loading, setLoading] = useState(false);
  const [balanceLoading, setBalanceLoading] = useState(true);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [EmployeeInfo, setEmployeeInfo] = useState();
  const [availableBalance, setAvailableBalance] = useState({
    yearly: 0,
    monthly: 0,
  });

  // Leave types configuration
const [leaveTypes, setLeaveTypes] = useState([]);
const [leaveTypesLoading, setLeaveTypesLoading] = useState(true);
const fetchLeaveTypes = async () => {
  try {
    setLeaveTypesLoading(true);

    const res = await axios.get(
      `${Base_URL}/Leave/GetLeavesInfo/${user?.userId}`
    );

    // API response:
    // [{ leaveId, leaveDescription }]
    const formatted = res.data.map(l => ({
      id: l.leaveDescription,          // IMPORTANT: keep description
      name: l.leaveDescription,
      leaveId: l.leaveId,
      key: l.leaveDescription,          // used for lookup
      color: "primary"
    }));

    setLeaveTypes(formatted);
  } catch (err) {
    console.error("Error fetching leave types", err);
    setLeaveTypes([]);
  } finally {
    setLeaveTypesLoading(false);
  }
};
const fetchConfirmedLeaveConfig = async () => {
  try {
    setConfirmedConfigLoading(true);

    const res = await axios.get(
      `${Base_URL}/Leave/getLeavesForConfirmedConfig/${user?.userId}`
    );

    setConfirmationEmployeeCheck(res.data?.confirmationEmployeeCheck ?? true);
    setConfirmedLeaveConfig(res.data?.leaves || []);
  } catch (err) {
    console.error("Error fetching confirmation leave config", err);

    // fail-safe: allow everything
    setConfirmationEmployeeCheck(true);
    setConfirmedLeaveConfig([]);
  } finally {
    setConfirmedConfigLoading(false);
  }
};


  // Function to calculate available leaves as of current day
  const calculateAvailableAsOfToday = (yearlyAllocation) => {
    if (!yearlyAllocation || yearlyAllocation === 0) return 0;

    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1;
    const currentDay = currentDate.getDate();
    const currentYear = currentDate.getFullYear();

    const daysInMonth = new Date(currentYear, currentMonth, 0).getDate();
    const monthlyAllocation = yearlyAllocation / 12;

    const dailyAllocation = monthlyAllocation / daysInMonth;
    const leavesAvailable = dailyAllocation * currentDay;

    return Math.round(leavesAvailable * 100) / 100;
  };

  const fetchLeaveBalances = async () => {
    try {
      setBalanceLoading(true);

      const mavroId = user?.userId;
      const now = new Date();
      const fiscalYear = now.getFullYear();
      const month = now.getMonth() + 1;

      const dynamicUrl = `${Base_URL}/Leave/LeaveBalance/${mavroId}/${fiscalYear}/${month}`;
      const response = await axios.get(dynamicUrl);
      const data = response.data;

      console.log("Leave Balance API Response:", data);
const balances = {};

if (data?.yearly?.balance) {
  data.yearly.balance.forEach(item => {
    balances[item.name] = item.balance;
  });
}

setLeaveBalances(balances);


      // setAvailableBalance({
      //   yearly: casualBalance + sickBalance + earnedBalance,
      //   monthly: 0,
      // });
    } catch (error) {
      console.error("Error fetching leave balances:", error);

      setLeaveBalances({
        casual: 0,
        sick: 0,
        earned: 0,
      });
    } finally {
      setBalanceLoading(false);
    }
  };

  useEffect(() => {
    if (user?.userId) {
      fetchLeaveBalances();
fetchLeaveTypes();
fetchConfirmedLeaveConfig();
      // Auto-refresh leave balances every hour
      const intervalId = setInterval(() => {
        console.log("🔄 Auto-refreshing leave balances...");
        fetchLeaveBalances();
      }, 60 * 60 * 1000); // Every hour

      return () => clearInterval(intervalId);
    }
  }, [user]);
  const isLeaveDisabledByConfirmation = (leaveDescription) => {
  if (confirmationEmployeeCheck) return false;

  const matched = confirmedLeaveConfig.find(
    l => l.leaveDescription === leaveDescription
  );

  return matched?.confirmationIndicator === true;
};


  const calculateDays = (fromDate, toDate, fromHalf, toHalf, duration) => {
    if (!fromDate || !toDate) return 0;

    const from = new Date(fromDate);
    const to = new Date(toDate);

    // Total calendar days (inclusive)
    const daysDiff = Math.floor((to - from) / (1000 * 60 * 60 * 24)) + 1;

    if (daysDiff <= 0) return 0;

    // FULL DAY MODE
    if (duration === "Full Day") {
      if (daysDiff === 1) return 1;
      return daysDiff;
    }

    // HALF DAY MODE

    // Same date
    if (daysDiff === 1) {
      if (fromHalf === "First Half" && toHalf === "First Half") return 0.5;
      if (fromHalf === "Second Half" && toHalf === "Second Half") return 0.5;
      if (fromHalf === "First Half" && toHalf === "Second Half") return 1;
      return 0.5;
    }

    // Multiple days with half logic
    let total = 0;

    // First day contribution
    total += fromHalf === "First Half" ? 1 : 0.5;

    // Last day contribution
    total += toHalf === "Second Half" ? 1 : 0.5;

    // Middle full days
    const middleDays = daysDiff - 2;
    if (middleDays > 0) total += middleDays;

    return total;
  };

  const handleDateChange = (field, value) => {
    const updated = { ...leaveData, [field]: value };

    // If fromDate changes and it's after toDate, reset toDate
    if (
      field === "fromDate" &&
      value &&
      updated.toDate &&
      new Date(value) > new Date(updated.toDate)
    ) {
      updated.toDate = value;
      updated.toHalf = updated.fromHalf;
    }

    updated.daysRequested = calculateDays(
      updated.fromDate,
      updated.toDate,
      updated.fromHalf,
      updated.toHalf,
      updated.duration
    );
    setLeaveData(updated);
  };

  const handleHalfChange = (field, value) => {
    const updated = { ...leaveData, [field]: value };
    updated.daysRequested = calculateDays(
      updated.fromDate,
      updated.toDate,
      updated.fromHalf,
      updated.toHalf,
      updated.duration
    );
    setLeaveData(updated);
  };

  const handleLeaveTypeChange = (type) => {
    const updated = { ...leaveData, leaveType: type };
    updated.daysRequested = calculateDays(
      updated.fromDate,
      updated.toDate,
      updated.fromHalf,
      updated.toHalf,
      updated.duration
    );
    setLeaveData(updated);
  };

  const handleDurationChange = (duration) => {
    const updated = { ...leaveData, duration };
    updated.daysRequested = calculateDays(
      updated.fromDate,
      updated.toDate,
      updated.fromHalf,
      updated.toHalf,
      duration
    );
    setLeaveData(updated);
  };

  const handleSubmitLeave = async () => {
    if (!leaveData.fromDate || !leaveData.toDate || !leaveData.leaveType) {
      setSubmitStatus({ type: "error", message: "Please fill all required fields" });
      return;
    }

    // Calculate available for selected leave type
    const selectedTypeKey = leaveTypes.find((t) => t.id === leaveData.leaveType)?.key;
    const yearlyAllocation = leaveBalances[leaveData.leaveType] || 0;


    // ✅ Only enforce balance check if NOT organisationId 9001
    if (isBalanceCheckEnabled && leaveData.daysRequested > yearlyAllocation) {
      const typeName = leaveTypes.find((t) => t.id === leaveData.leaveType)?.name;
      setSubmitStatus({
        type: "error",
        message: `Insufficient ${typeName} balance. Annual allocation: ${yearlyAllocation.toFixed(
          1
        )} days, Requested: ${leaveData.daysRequested} days`,
      });
      return;
    }

    setLoading(true);
    setSubmitStatus(null);

    try {
      const leavePayload = {
        UserId: user?.userId?.toString(),
        ResourceId: user?.resourceId || user?.userId?.toString() || "default",
        OrganisationId: user?.organisationId?.toString(),
        CompanyCode: user?.companyCode?.toString(),
        StartLeaveDate: new Date(leaveData.fromDate),
        EndLeaveDate: new Date(leaveData.toDate),
        LeaveDuration: leaveData.daysRequested,
        LeaveType: leaveData.leaveType,
        LeavePolicyId: user?.leavePolicyId,
        Note: leaveData.note || "Leave application",
      };

      console.log("Sending leave payload:", leavePayload);

      const response = await axios.post(`${Base_URL}/Leave/ApplyLeave`, leavePayload);

      setSubmitStatus({
        type: "success",
        message: "Leave request submitted successfully! Email sent to HR.",
      });

      // Refresh balances after successful submission
      fetchLeaveBalances();

      // Reset form after success
      setTimeout(() => {
        setLeaveData({
          fromDate: "",
          toDate: "",
          fromHalf: "First Half",
          toHalf: "First Half",
          leaveType: "",
          note: "",
          duration: "Full Day",
          daysRequested: 0,
        });
      }, 2000);
    } catch (error) {
      console.error("Error submitting leave request:", error);

      if (error.response) {
        setSubmitStatus({
          type: "error",
          message:
            error.response.data ||
            "Failed to submit leave request. Please try again.",
        });
      } else if (error.request) {
        setSubmitStatus({
          type: "error",
          message: "Network error. Please check your connection and try again.",
        });
      } else {
        setSubmitStatus({
          type: "error",
          message: error.message || "Failed to submit leave request. Please try again.",
        });
      }
    } finally {
      setLoading(false);
    }
  };

  // Update leave types with current balances and insufficient balance check
 const updatedLeaveTypes = leaveTypes.map((type) => {
  const available = leaveBalances[type.id] || 0;
  const disabledByConfirmation = isLeaveDisabledByConfirmation(type.name);

  return {
    ...type,
    available,
    disabledByConfirmation, // ✅ NEW FLAG
    insufficientBalance:
      isBalanceCheckEnabled &&
      leaveData.leaveType === type.id &&
      leaveData.daysRequested > available,
  };
});


  const selectedLeaveType = updatedLeaveTypes.find(
    (t) => t.id === leaveData.leaveType
  );

  return (
    <div className="request-leave-screen-container bg-light">
      <div className="leave-screen-header">
        <Button
          variant="link"
          className="back-leave-screen-btn"
          onClick={() => navigate(-1)}
          disabled={loading}
        >
          ← Back
        </Button>
        <h3 className="leave-screen-page-title">Request Leave</h3>
      </div>

      {submitStatus && (
        <Alert
          variant={submitStatus.type === "success" ? "success" : "danger"}
          className="mt-3"
        >
          {submitStatus.message}
        </Alert>
      )}

      <Card className="leave-screen-form-card">
        <Card.Body className="p-4">
          {/* Date Selection with Half Day Dropdown */}
          <Row className="mb-4">
            <Col md={6}>
              <Form.Group>
                <Form.Label className="fw-semibold leave-screen-label-text">
                  From Date *
                </Form.Label>
                <Form.Control
                  type="date"
                  value={leaveData.fromDate}
                  onChange={(e) => handleDateChange("fromDate", e.target.value)}
                  className="leave-screen-date-input mb-2"
                  disabled={loading}
                />

                <Form.Select
                  value={leaveData.fromHalf}
                  onChange={(e) => handleHalfChange("fromHalf", e.target.value)}
                  disabled={loading || !leaveData.fromDate}
                  className="leave-screen-half-select"
                >
                  <option value="First Half">First Half</option>
                  <option value="Second Half">Second Half</option>
                </Form.Select>

                <div className="leave-screen-date-display">
                  {leaveData.fromDate
                    ? new Date(leaveData.fromDate).toLocaleDateString("en-GB", {
                        day: "numeric",
                        month: "short",
                        year: "numeric",
                      })
                    : "Select date"}
                  {` (${leaveData.fromHalf})`}
                </div>
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group>
                <Form.Label className="fw-semibold leave-screen-label-text">
                  To Date *
                </Form.Label>
                <Form.Control
                  type="date"
                  value={leaveData.toDate}
                  onChange={(e) => handleDateChange("toDate", e.target.value)}
                  className="leave-screen-date-input mb-2"
                  min={leaveData.fromDate}
                  disabled={loading || !leaveData.fromDate}
                />

                <Form.Select
                  value={leaveData.toHalf}
                  onChange={(e) => handleHalfChange("toHalf", e.target.value)}
                  disabled={loading || !leaveData.toDate}
                  className="leave-screen-half-select"
                >
                  <option value="First Half">First Half</option>
                  <option value="Second Half">Second Half</option>
                </Form.Select>

                <div className="leave-screen-date-display">
                  {leaveData.toDate
                    ? new Date(leaveData.toDate).toLocaleDateString("en-GB", {
                        day: "numeric",
                        month: "short",
                        year: "numeric",
                      })
                    : "Select date"}
                  {` (${leaveData.toHalf})`}
                </div>
              </Form.Group>
            </Col>
          </Row>

          {/* Days Counter */}
          <div className="leave-screen-days-counter text-center mb-4">
            <div className="leave-screen-days-badge">
              <span className="leave-screen-days-number">
                {leaveData.daysRequested}
              </span>
              <span className="leave-screen-days-text">days</span>
            </div>
          </div>

          {/* Leave Type Selection */}
          <div className="mb-4">
            <h6 className="fw-semibold mb-3 leave-screen-section-title">
              Select type of leave you want to apply *
            </h6>
            <div className="leave-screen-types-container">
              {updatedLeaveTypes.map((type) => {
                const yearlyAllocation = leaveBalances[type.key] || 0;
                const availableAsOfToday =
                  calculateAvailableAsOfToday(yearlyAllocation);

                return (
                  <div
                    key={type.id}
                    className={`leave-screen-type-card
  ${leaveData.leaveType === type.id ? "selected" : ""}
  ${type.insufficientBalance ? "insufficient" : ""}
  ${type.disabledByConfirmation ? "disabled" : ""}
`}

                    onClick={() => {
  if (loading || type.disabledByConfirmation) return;
  handleLeaveTypeChange(type.id);
}}

                  >
                    <div className="d-flex justify-content-between align-items-start mb-2">
                      <div className="leave-screen-type-header">
                        <h6 className="leave-screen-type-name mb-1">
                          {type.icon && (
                            <span className="me-2">{type.icon}</span>
                          )}
                          {type.name}
                        </h6>
                        <div className="leave-screen-balance-info">
                          <small className="leave-screen-available-days">
                            {balanceLoading ? (
                              <Spinner animation="border" size="sm" />
                            ) : (
                              <>
                                <div>
                                  <strong>{yearlyAllocation} days</strong>{" "}
                                  available
                                </div>
                              </>
                            )}
                          </small>
                        </div>
                      </div>
                      <div className="leave-screen-status-indicators">
                        {type.insufficientBalance && (
                          <Badge
                            bg="danger"
                            className="leave-screen-warning-badge"
                          >
                            !
                          </Badge>
                        )}
                      </div>
                    </div>

                    {type.insufficientBalance && (
                      <Alert
                        variant="warning"
                        className="leave-screen-warning-alert mb-2"
                      >
                        <small>• Insufficient balance for {type.name}</small>
                      </Alert>
                    )}
                  </div>
                );
              })}
            </div>
          </div>

          {/* Duration Selection */}
          <div className="mb-4">
            <h6 className="fw-semibold mb-3 leave-screen-section-title">
              Duration *
            </h6>
            <div className="leave-screen-duration-options">
              <Button
                variant={
                  leaveData.duration === "Full Day"
                    ? "primary"
                    : "outline-primary"
                }
                className="leave-screen-duration-btn"
                onClick={() => !loading && handleDurationChange("Full Day")}
                disabled={loading}
              >
                Full Day
              </Button>
              <Button
                variant={
                  leaveData.duration === "Half Day"
                    ? "primary"
                    : "outline-primary"
                }
                className="leave-screen-duration-btn"
                onClick={() => !loading && handleDurationChange("Half Day")}
                disabled={loading}
              >
                Half Day
              </Button>
            </div>
          </div>

          {/* Days Requested Info */}
          <div className="leave-screen-days-requested-info text-center mb-4">
            <p className="mb-0 text-muted">
              You are requesting for{" "}
              <strong>{leaveData.daysRequested} days</strong> of leave
              {selectedLeaveType && (
                <span>
                  {" "}
                  • Available:{" "}
                  <strong>{selectedLeaveType.available} days</strong>
                </span>
              )}
            </p>
          </div>

          {/* Note Section */}
          <div className="mb-4">
            <Form.Group>
              <Form.Label className="fw-semibold leave-screen-section-title">
                Note
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Add any additional information here..."
                value={leaveData.note}
                onChange={(e) =>
                  setLeaveData({ ...leaveData, note: e.target.value })
                }
                className="leave-screen-note-textarea"
                disabled={loading}
              />
            </Form.Group>
          </div>
        </Card.Body>
      </Card>

      {/* Action Buttons */}
      <div className="leave-screen-action-buttons fixed-bottom d-flex justify-content-center">
        <Row className="g-2 w-auto">
          <Col xs="auto">
            <Button
              variant="outline-secondary"
              className="leave-screen-action-btn leave-screen-cancel-btn"
              onClick={() => navigate(-1)}
              disabled={loading}
            >
              Cancel
            </Button>
          </Col>

          <Col xs="auto">
            <Button
              variant="primary"
              className="leave-screen-action-btn leave-screen-request-btn"
              onClick={handleSubmitLeave}
              disabled={
                !leaveData.fromDate ||
                !leaveData.toDate ||
                !leaveData.leaveType ||
                loading
              }
            >
              {loading ? <Spinner animation="border" size="sm" /> : "Request Leave"}
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default RequestLeave;
